import React from "react";
import { Icon, Link, List, Text } from "@telia/teddy";

const EmptyCart: React.FC = () => (
    <div>
        <Text mb="100">
            Din handlekurv er tom <br />
            Gå til:
        </Text>
        <List layout="vertical" gapSize="small">
            <List.Item>
                <List.Illustration variant="image">
                    <Icon name="chevron-right" aria-hidden="true" />
                </List.Illustration>
                <List.Content>
                    <Link variant="text" href="/mobiltelefoner/">
                        Mobiltelefoner
                    </Link>
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Illustration variant="image">
                    <Icon name="chevron-right" aria-hidden="true" />
                </List.Illustration>
                <List.Content>
                    <Link variant="text" href="/mobilabonnement/">
                        Mobilabonnement
                    </Link>
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Illustration variant="image">
                    <Icon name="chevron-right" aria-hidden="true" />
                </List.Illustration>
                <List.Content>
                    <Link variant="text" href="/internett/">
                        Internett
                    </Link>
                </List.Content>
            </List.Item>
        </List>
    </div>
);

export default EmptyCart;
